import { useState } from "react"
import styled from "styled-components"
import { BsChevronDown } from "react-icons/bs"
import { BsChevronUp } from "react-icons/bs"
import ExpandedMenuMobile0 from "./ExpandedMenuMobile0"
import ExpandedMenuMobile1 from "./ExpandedMenuMobile1"
import ExpandedMenuMobile2 from "./ExpandedMenuMobile2"
import { StyledButton } from "../Buttons"
import { useCookies } from "react-cookie"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

const MenuMobile = () => {
  const [menuOption, setMenuOption] = useState<number | null>(null)
  const [, , removeCookie] = useCookies(["accessToken", "user"])
  const navigate = useNavigate()

  const handleMenuOptionClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    const option = parseInt(e.currentTarget.value)
    if (menuOption === option) {
      setMenuOption(null)
    } else {
      setMenuOption(option)
    }
  }

  const handleLogout = () => {
    removeCookie("accessToken", { path: "/" })
    removeCookie("user", { path: "/" })
    toast.success("성공적으로 로그아웃되었습니다.")
    navigate("/")
  }

  return (
    <Container>
      <MenuList>
        <MenuButton
          value={0}
          onClick={handleMenuOptionClick}
          $selected={menuOption === 0}
        >
          소개 {menuOption === 0 ? <BsChevronUp /> : <BsChevronDown />}
        </MenuButton>
        <SubMenuContainer $expanded={menuOption === 0}>
          <ExpandedMenuMobile0 />
        </SubMenuContainer>
        <MenuButton
          value={1}
          onClick={handleMenuOptionClick}
          $selected={menuOption === 1}
        >
          학문 적성 검사{" "}
          {menuOption === 1 ? <BsChevronUp /> : <BsChevronDown />}
        </MenuButton>
        <SubMenuContainer $expanded={menuOption === 1}>
          <ExpandedMenuMobile1 />
        </SubMenuContainer>
        <MenuButton
          value={2}
          onClick={handleMenuOptionClick}
          $selected={menuOption === 2}
        >
          문의 {menuOption === 2 ? <BsChevronUp /> : <BsChevronDown />}
        </MenuButton>
        <SubMenuContainer $expanded={menuOption === 2}>
          <ExpandedMenuMobile2 />
        </SubMenuContainer>
      </MenuList>
      <ButtonContainer>
        <LogoutButton onClick={handleLogout}>로그아웃</LogoutButton>
      </ButtonContainer>
    </Container>
  )
}

export default MenuMobile

const Container = styled.div`
  height: calc(100% - 60px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const MenuList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-top: 1px solid var(--custom-platinum);
`

const MenuButton = styled.button<{ $selected: boolean }>`
  all: unset;
  height: 80px;
  line-height: 80px;
  font-size: 20px;
  font-weight: bold;
  color: ${(props) =>
    props.$selected ? "var(--custom-blue)" : "var(--custom-deep-dark-brown)"};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;

  &:hover {
    background-color: var(--custom-anti-flash-white);
    color: var(--custom-blue);
  }

  &:active {
    background-color: var(--custom-anti-flash-white);
    color: var(--custom-blue);
  }
`

const SubMenuContainer = styled.div<{ $expanded: boolean }>`
  transition: all 1s ease-in-out;
  height: auto;
  overflow: hidden;
  border-bottom: 1px solid var(--custom-platinum);
  max-height: ${(props) => (props.$expanded ? "600px" : "1px")};
`

const ButtonContainer = styled.div`
  padding: 20px 30px;
`

const LogoutButton = styled(StyledButton).attrs(() => ({
  $textColor: "var(--custom-light-red)",
  $bgColor: "var(--custom-anti-flash-white)",
  $hoverColor: "var(--custom-platinum)",
  $activeColor: "var(--custom-platinum)",
  $activeTextColor: "var(--custom-light-red)",
}))`
  border-radius: 10px;
  font-weight: bold;
  border: none;
`
